import * as components from './components'
import * as hooks from './hooks'

console.log('Promocodeds feature initialized!')

export { components, hooks }
